export const categories = [
  {
    slug: 'east-asia',
    name: '东亚春色',
    description: '樱花如雪，古韵悠长。探索日本、韩国、中国的春日绝景，感受千年文化与自然之美的完美交融。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20cherry%20blossoms%20in%20full%20bloom%20along%20ancient%20temple%20path%2C%20soft%20pink%20petals%20falling%20like%20snow%2C%20traditional%20wooden%20architecture%20with%20curved%20roofs%2C%20spring%20morning%20light%2C%20ethereal%20atmosphere%2C%20dreamy%20pastel%20color%20palette%2C%20editorial%20travel%20photography%20with%20shallow%20depth%20of%20field&width=800&height=500&seq=east-asia-spring-01&orientation=landscape',
    region: '日本 · 韩国 · 中国',
    articles: ['japan-sakura-guide', 'korea-spring-flowers', 'china-jiangnan-spring'],
  },
  {
    slug: 'southeast-asia',
    name: '东南亚春色',
    description: '热带花海，异域风情。漫步越南、泰国、印尼的春日画卷，沉醉于热情奔放的东南亚春日盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Tropical%20flower%20fields%20in%20Southeast%20Asia%20at%20sunrise%2C%20vivid%20orange%20and%20yellow%20blooms%2C%20traditional%20wooden%20longtail%20boat%20on%20calm%20river%2C%20misty%20morning%20atmosphere%2C%20lush%20green%20palm%20trees%2C%20warm%20golden%20light%2C%20peaceful%20rural%20scene%2C%20travel%20editorial%20photography&width=800&height=500&seq=se-asia-spring-01&orientation=landscape',
    region: '越南 · 泰国 · 印尼',
    articles: ['vietnam-hoi-an-spring', 'thailand-chiang-mai-flowers', 'indonesia-bali-spring'],
  },
  {
    slug: 'south-asia',
    name: '南亚春色',
    description: '雪山花季，色彩盛宴。探寻印度、尼泊尔、斯里兰卡的春日秘境，在高原与茶园间遇见最美春天。',
    image: 'https://readdy.ai/api/search-image?query=Himalayan%20foothills%20with%20rhododendron%20blooms%20in%20spring%2C%20terraced%20tea%20plantations%20with%20snow-capped%20mountains%20in%20background%2C%20vibrant%20red%20and%20pink%20flowers%2C%20crystal%20clear%20morning%20sky%2C%20traditional%20stone%20cottages%2C%20serene%20atmosphere%2C%20travel%20editorial%20photography&width=800&height=500&seq=south-asia-spring-01&orientation=landscape',
    region: '印度 · 尼泊尔 · 斯里兰卡',
    articles: ['india-darjeeling-spring', 'nepal-pokhara-rhododendron', 'sri-lanka-tea-spring'],
  },
];

export const categoryKeywords: Record<string, string[]> = {
  'east-asia': ['日本樱花', '韩国春花', '中国江南春色', '京都哲学之道', '济州岛油菜花', '苏州园林春景'],
  'southeast-asia': ['越南会安', '泰国清迈花节', '印尼巴厘岛', '热带花海', '水上市场春日', '乌布梯田'],
  'south-asia': ['印度大吉岭', '尼泊尔博卡拉', '斯里兰卡茶山', '杜鹃花季', '喜马拉雅春色', '高山茶园'],
};